import type { Page } from '@vgtv/api-client/lib/page';
import { ComponentType } from '@vgtv/api-client/lib/component';

function pageStartsWithSplash(pageConfiguration?: Page): boolean {
  const componentType = pageConfiguration?.components?.[0]?.type;

  return (
    componentType === ComponentType.SPLASH ||
    componentType === ComponentType.CAROUSEL
  );
}

export { pageStartsWithSplash };
